import { RecurringSettingsMonthRepeatMode } from "@ticketingplatform/api/dist/__generated__/globalTypes";

import { RecurringMode } from "./partials/RecurringSettingsForm/enums";
import { RecurringSettingsFieldProps } from "./types";

export const RECURRING_SETTINGS_FORM_INITIAL_VALUES: Partial<
  RecurringSettingsFieldProps["value"]
> = {
  monthRepeatMode: RecurringSettingsMonthRepeatMode.MONTH_DAY,
  mode: RecurringMode.END_AT,
};
